<template>
  <div id="manage">
    <el-tabs type="border-card">
      <el-tab-pane label="资金调整">
        <div>
          <div>
            <table
              v-if="data.budget"
              width="900"
              border="1"
              cellpadding="0"
              cellspacing="0"
              bordercolor="#ddd"
              style="border-collapse:collapse;margin-bottom:30px;"
            >
              <tr>
                <td class="t" width="200">金额总览</td>
                <td class="t" width="200">设备费</td>
                <td class="t" width="200">材料费</td>
                <td class="t" width="200">咨询费</td>
                <td class="t" width="100">操作</td>
              </tr>
              <tr>
                <td class="v">直接费用</td>
                <td class="v">{{data.budget.equipment}}</td>
                <td class="v">{{data.budget.material}}</td>
                <td class="v">{{data.budget.consult}}</td>
                <td class="v" rowspan="2" align="center">
                  <el-link @click="changeDialog=true">调整</el-link>
                </td>
              </tr>
              <tr>
                <td class="v">剩余</td>
                <td class="v">{{data.surplus.equipment}}</td>
                <td class="v">{{data.surplus.material}}</td>
                <td class="v">{{data.surplus.consult}}</td>
              </tr>
            </table>
          </div>
          <div>
            <div align="center" class="lv3Text" style="margin-bottom:10px;">项目执行资金调增/调减记录</div>
            <div v-if="list">
              <el-table :data="list" style="width: 100%">
                <el-table-column label="时间">
                  <template slot-scope="scope">
                    <span>{{ dayjs.unix(scope.row.create_date).format('YYYY/MM/DD') }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="from" label="调出"></el-table-column>
                <el-table-column prop="to" label="调入"></el-table-column>
                <el-table-column prop="money" label="金额"></el-table-column>
                <el-table-column prop="name" label="调整人"></el-table-column>
                <el-table-column label="批复文件">
                  <template slot-scope="scope">
                    <a v-if="scope.row.file != ''" :href="serve+scope.row.file" target="_blank">下载</a>
                    <a v-else @click="alert_download_error()">下载</a>
                  </template>
                </el-table-column>
                <el-table-column prop="info" label="备注"></el-table-column>
                <el-table-column label="操作" width="180">
                  <template slot-scope="scope">
                    <el-link @click="del(scope.row.id)">删除</el-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pager" align="center">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :page-size="10"
                @current-change="changePage"
                hide-on-single-page
              ></el-pagination>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="项目执行资金调增/调减记录" :visible.sync="changeDialog" width="550px" center>
      <div>
        <el-form label-position="right" label-width="100px">
          <el-form-item label="调出：">
            <el-button plain @click="from='设备费'" :class="from=='设备费'?'active':''">设备费</el-button>
            <el-button plain @click="from='材料费'" :class="from=='材料费'?'active':''">材料费</el-button>
            <el-button plain @click="from='咨询费'" :class="from=='咨询费'?'active':''">咨询费</el-button>
          </el-form-item>
          <el-form-item label="调入：">
            <el-button plain @click="to='设备费'" :class="to=='设备费'?'active':''">设备费</el-button>
            <el-button plain @click="to='材料费'" :class="to=='材料费'?'active':''">材料费</el-button>
            <el-button plain @click="to='咨询费'" :class="to=='咨询费'?'active':''">咨询费</el-button>
          </el-form-item>
          <el-form-item label="输入金额：">
            <el-input v-model="form.money" style="width:200px"></el-input>
          </el-form-item>
          <el-form-item label="调整人：">
            <el-input v-model="form.name" style="width:200px"></el-input>
          </el-form-item>
          <el-form-item label="批复文件：">
            <input type="file" @change="getFile($event)">
          </el-form-item>
          <el-form-item label="备注：">
            <el-input type="textarea" :rows="2" style="width:300px" v-model="form.info"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,

      data: {},
      changeDialog: false,
      form: {},
      from: "",
      to: "",
      list: [],
      page: 1,
      total: 0
    };
  },
  created() {
    //
    this.$store.state.user_location = "经费管理";
    this.$store.state.leftMenuIndex = 20;
    this.initData();
  },
  methods: {
    alert_download_error(){
      this.$message({
        message: '此记录未上传审批文件',
        type: 'error',
        offset: 200
      })
    },
    //
    del(id) {
      this.axios
        .get(this.serve + "/personal/del_adjust", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            id: id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              message: "记录已删除",
              type: "success"
            });
            this.axios
              .get(this.serve + "/personal/adjust_money_log", {
                params: {
                  mobile: this.$cookies.get("user"),
                  token: this.$cookies.get("token"),
                  project_id: this.$route.params.id,
                  page: 1
                }
              })
              .then(res => {
                if (res.data.data) {
                  this.list = res.data.data.results;
                  this.total = res.data.data.total;
                } else {
                  this.list = [];
                  this.total = 0;
                }
              });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    changePage(p) {
      this.page = p;
      this.axios
        .get(this.serve + "/personal/adjust_money_log", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            project_id: this.$route.params.id,
            page: p
          }
        })
        .then(res => {
          if (res.data.data) {
            this.list = res.data.data.results;
            this.total = res.data.data.total;
          } else {
            this.list = [];
            this.total = 0;
          }
        });
    },
    setFrom(v) {
      this.from = v;
    },
    getFile(event) {
      this.form.file = event.target.files[0];
    },
    submit() {
      let formData = new FormData();
      formData.append("mobile", this.$cookies.get("user"));
      formData.append("token", this.$cookies.get("token"));
      formData.append("project_id", this.$route.params.id);
      formData.append("from", this.from);
      formData.append("to", this.to);
      formData.append("money", this.form.money);
      formData.append("file", this.form.file);
      formData.append("name", this.form.name);
      formData.append("info", this.form.info);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.axios
        .post(
          this.serve + "/personal/adjust_money",
          formData,
          config
        )
        .then(res => {
          if (res.data.status == "success") {
            this.$message({
              message: "记录调整成功",
              type: "success"
            });
            this.changeDialog = false;
            this.from = "";
            this.to = "";
            this.from = {};
            this.axios
              .get(this.serve + "/personal/adjust_money_log", {
                params: {
                  mobile: this.$cookies.get("user"),
                  token: this.$cookies.get("token"),
                  project_id: this.$route.params.id,
                  page: 1
                }
              })
              .then(res => {
                if (res.data.data) {
                  this.list = res.data.data.results;
                  this.total = res.data.data.total;
                } else {
                  this.list = [];
                  this.total = 0;
                }
              });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    initData() {
      this.axios
        .get(this.serve + "/personal/budget", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            id: this.$route.params.id
          }
        })
        .then(res => {
          //
          this.data = res.data;
        });

      this.axios
        .get(this.serve + "/personal/adjust_money_log", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            project_id: this.$route.params.id,
            page: 1
          }
        })
        .then(res => {
          if (res.data.data) {
            this.list = res.data.data.results;
            this.total = res.data.data.total;
          } else {
            this.list = [];
            this.total = 0;
          }
        });
    }
  }
};
</script>
<style lang="scss">
#manage {
  .el-button.active {
    color: #e2211c;
    border: 1px solid #e2211c;
  }
  .t {
    background-color: #f5faf9;
    padding: 10px 20px;
    text-align: center;
  }
  .v {
    padding: 10px 20px;
    .el-link {
      margin-right: 20px;
    }
  }
}
</style>